export const CUSTOM_EMPTY_STATE_KEY = {
  PEOPLE_SETUP: "peopleSetup",
  PEOPLE_EMPTY_RESULTS: "peopleEmptyResults",
  NEWS_SETUP: "newsSetup",
  NEWS_EMPTY_RESULTS: "newsEmptyResults",
  ORG_CHART_SETUP: "orgchartSetup",
};

export const CUSTOM_EMPTY_STATE_TEMPLATE = {
  [CUSTOM_EMPTY_STATE_KEY.PEOPLE_SETUP]: (themeName) => ({
    title: "add-people-to-get-started",
    description: "select-people-in-the-sidebar",
    imageUrl: `/img/contentviz/people/empty-state-${themeName}.svg`,
  }),
  [CUSTOM_EMPTY_STATE_KEY.PEOPLE_EMPTY_RESULTS]: (themeName) => ({
    title: "nothing-matches-your-search",
    description: "remove-any-filters-or-search-less",
    imageUrl: `/img/contentviz/people/empty-state-${themeName}.svg`,
  }),
  [CUSTOM_EMPTY_STATE_KEY.NEWS_SETUP]: (themeName) => ({
    title: "add-news-to-get-started",
    description: "select-news-in-the-sidebar",
    imageUrl: `/img/contentviz/news/empty-state-${themeName}.svg`,
  }),
  [CUSTOM_EMPTY_STATE_KEY.NEWS_EMPTY_RESULTS]: (themeName) => ({
    title: "nothing-matches-your-search",
    description: "remove-any-filters-or-search-less",
    imageUrl: `/img/contentviz/news/empty-state-${themeName}.svg`,
  }),
  [CUSTOM_EMPTY_STATE_KEY.ORG_CHART_SETUP]: (themeName) => ({
    title: "add-people-to-get-started",
    description: "select-org-chart-in-the-sidebar",
    imageUrl: `/img/contentviz/people/empty-state-${themeName}.svg`,
  }),
};
